export const LOGIN_STATUS_SESSION_KEY = "is_logged_in"
export const CSRF_TOKEN_SESSION_KEY = "csrf_token"
export const LOGIN_RETURN_URI_SESSION_KEY = "login_return_uri"
export const QUERY_STRING_SESSION_KEY = "queryStringParams"
